import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DatepickerComponent } from './datepicker.component';
import { IonicModule } from '@ionic/angular';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  declarations: [DatepickerComponent],
  imports: [
    CommonModule,
    IonicModule,
    MatDatepickerModule,
    MatInputModule,
    FontAwesomeModule
  ],
  exports: [DatepickerComponent]
})
export class DatepickerComponentModule {}
